// src/components/dashboard/bookings/rentToOwnSaveAllowlist.js
// FT-173 STEP-18 (REQ-13 сохранение, CTR-06): белый список полей payload
// editSave() (BookingCard.vue), разрешённых к сохранению у ДОГОВОРНОГО
// бронирования (booking.rent_to_own === true). Источник — снимок серверного
// Api::V1::PricedBookingsController::NON_PRICING_PERMITTED_FIELDS /
// NON_PRICING_PERMITTED_ARRAY_FIELDS (tests/unit/bookings/fixtures/
// non_pricing_permitted_fields.json, STEP-14, OQ-02) МИНУС 10 полей, которые
// сервер защищает от записи модульным писателем договора выкупа
// (Booking::RENT_TO_OWN_MANAGED_FIELDS, STEP-05): деньги и денежный режим
// (client_id, hourly_deposit, weekly_deposit, monthly_deposit,
// payments_type, payments_period), тариф (tariff_id) и коммерческие условия
// такси (periodic_pricing_method, taxi_payment_model, commission_percent).
//
// tests/unit/bookings/rentToOwnSaveAllowlist.spec.js сверяет обе константы
// ниже со снимком: полное разбиение — каждое поле снимка либо в белом
// списке, либо в списке исключений, никогда в обоих одновременно.
export const RENT_TO_OWN_SAVE_EXCLUDED_FIELDS = Object.freeze([
  "client_id",
  "hourly_deposit",
  "weekly_deposit",
  "monthly_deposit",
  "payments_type",
  "tariff_id",
  "payments_period",
  "periodic_pricing_method",
  "taxi_payment_model",
  "commission_percent",
]);

export const RENT_TO_OWN_SAVE_ALLOWLIST_FIELDS = Object.freeze([
  "description",
  "location_start",
  "location_end",
  "responsible",
  "entity",
  "entity_name",
  "custom_field_1",
  "custom_field_2",
  "custom_field_3",
  "state",
  "car_code",
  "fio",
  "serial_number",
  "car_name",
  "first_name",
  "middle_name",
  "last_name",
  "agent_id",
  "chair",
  "chairs_quantity",
  "chair_less_1_year",
  "booster",
  "boosters_quantity",
  "navigator",
  "mp3",
  "charger",
  "wifi_router",
  "osago",
  "kasko",
  "super_kasko",
  "theft",
  "no_franchise",
  "gas_start",
  "gas_end",
  "gas_start_full",
  "gas_end_full",
  "clean_start",
  "clean_end",
  "other_equipment",
  "failure",
  "booking_mileage",
  "start_mileage",
  "end_mileage",
  "send_accept_email",
  "send_cancel_email",
  "send_custom_email",
  "start_worker_id",
  "end_worker_id",
  "technical",
  "repair",
  "source",
  "client_category",
  "client_debtor",
  "oil_engine",
  "oil_engine_km",
  "grm",
  "grm_km",
  "car_state",
  "fast_booking",
  "responsible_id",
  "technical_check_start_comment",
  "technical_check_end_comment",
  "technical_check_start",
  "technical_check_end",
  "checkin_damage_image_url",
  "checkout_damage_image_url",
]);

export const RENT_TO_OWN_SAVE_ALLOWLIST_ARRAY_FIELDS = Object.freeze(["add_drivers"]);

// Плоское множество обоих списков — для фильтрации payload editSave().
const RENT_TO_OWN_SAVE_ALLOWLIST_SET = new Set([
  ...RENT_TO_OWN_SAVE_ALLOWLIST_FIELDS,
  ...RENT_TO_OWN_SAVE_ALLOWLIST_ARRAY_FIELDS,
]);

// REQ-13, CTR-06: применяется к уже построенному payload editSave() ТОЛЬКО
// при booking.rent_to_own — отбрасывает всё, что не входит в белый список
// (цены, скидки, services, gifts, manual_price/price_source, даты, car_id,
// периоды и деньги/тариф из RENT_TO_OWN_SAVE_EXCLUDED_FIELDS), оставляя
// только нефинансовые операционные поля.
export function filterToRentToOwnAllowlist(payload) {
  const result = {};
  Object.keys(payload).forEach((key) => {
    if (RENT_TO_OWN_SAVE_ALLOWLIST_SET.has(key)) {
      result[key] = payload[key];
    }
  });
  return result;
}
